import styled from 'styled-components'

export const Container = styled.div`
  label {
    cursor: pointer;
  }
`

export const EntireOrderContainer = styled.div`
  padding: 20px 20px 0;
  border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};

  > div {
    padding: 0 0 20px;
  }
`

export const IndividualItemsContainer = styled.div`
  padding: 20px;
`

export const AddGiftMessageContainer = styled.div`
  margin: 20px 0;
  border: 1px solid ${props => props.theme.palette.general.greyLight};
`
